module.exports = __webpack_public_path__ + "static/media/mutiselect_checked.654a1361.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/mutiselect_checked.svg
// module id = 1656
// module chunks = 0